import { UseFormReturnType } from '@mantine/form';

import { TextInput } from '@components';

interface TransitInputHeaderProps {
  form: UseFormReturnType<any>;
  parents: any[];
  name: string;
  disabled: boolean;
  label?: string;
}

export const TransitInputHeader: React.FC<TransitInputHeaderProps> = ({ form, parents, name, disabled, label }) => {
  const parentValue = parents?.find((parent) => !!parent);

  return (
    <TextInput
      {...form.getInputProps(name)}
      {...(!parentValue
        ? {
            disabled,
          }
        : {
            disabled: true,
            value: parentValue,
          })}
      label={label}
    />
  );
};
